module.exports = __webpack_public_path__ + "static/media/arrowRight.3ab0f758.svg";